import { Controller, useFormContext } from 'react-hook-form'
import { FormInput } from '../../functions/types'
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Box,
  FormHelperText,
  Typography,
  Select,
  TextField,
  MenuItem,
  Link
} from '@mui/material'
import { useFormStore } from '../../functions/formStore'

const InputForm = (): JSX.Element => {
  const {
    formState: { errors },
    control,
    setValue
  } = useFormContext<FormInput>()

  const { setData, data } = useFormStore()
  const optionsNo1: FormInput["No1"][] = ["不動産オーナーさま", "不動産管理会社さま", "家賃債務保証会社さま"]
  const optionsNo2: FormInput["No2"][] = ["法人", "個人"]
  const optionsNo5: FormInput["No5"][] = ["経営者・役員", "部長", "課長・次長", "係長・主任", "担当", "その他"]
  const optionsNo12: FormInput["No12"][] = ["インターネット検索", "メルマガ", "不動産管理会社の紹介", "家賃債務保証会社の紹介", "その他"]
  const optionsNo13: FormInput["No13"][] = ["打合せで説明を聞きたい", "説明資料の送付を希望します。", "両方", "その他"]
  const optionsNo15: FormInput["No15"][] = ["上記の個人情報保護基本方針について同意します"]
  return (
    <Box>
      <Box display="grid" justifyContent={"center"} marginY={5}>
        <Typography variant="h6" borderBottom={2} borderColor={"GrayText"} color="gray">テラシテRに関するお問合せ</Typography>
      </Box>
      <Box display={"flex"} flexDirection={"column"} justifyContent={"center"} >
        <FormControl component="fieldset" margin="normal" required>
          <FormLabel component="legend">お客さまについて</FormLabel>
          <Controller
            name="No1"
            control={control}
            render={({ field }) => (
              <RadioGroup {...field}>
                {
                  optionsNo1.map((option) => {
                    return (
                      <FormControlLabel value={option} control={<Radio />} label={option} onChange={() => {
                        setData({ ...data, No1: option })
                        setValue("No1", option, { shouldValidate: true })
                      }
                      } />
                    )
                  })
                }
              </RadioGroup>
            )}
          />
          <FormHelperText error>{errors.No1?.message}</FormHelperText>
        </FormControl>
        <FormControl component="fieldset" margin="normal" required>
          <FormLabel component="legend">法人・個人</FormLabel>
          <Controller
            name="No2"
            control={control}
            render={({ field }) => (
              <RadioGroup {...field}>
                {
                  optionsNo2.map((option) => {
                    return (
                      <FormControlLabel value={option} control={<Radio />} label={option} onChange={() => {
                        setData({ ...data, No2: option })
                        setValue("No2", option, { shouldValidate: true })
                      }
                      } />
                    )
                  })
                }
              </RadioGroup>
            )}
          />
          <FormHelperText error>{errors.No2?.message}</FormHelperText>
        </FormControl>
        <FormControl component="fieldset" margin="normal">
          <FormLabel component="legend">会社名・組織名</FormLabel>
          <Controller
            name="No3"
            control={control}
            render={({ field }) => (
              <TextField {...field} required={false} fullWidth margin="normal" value={data.No3} inputMode="text" multiline={false} placeholder={"中部電力ミライズコネクト株式会社"} onChange={(event) => {
                setData({ ...data, No3: event.target.value })
                setValue("No3", event.target.value, { shouldValidate: true })
              }
              } />
            )}
          />
          <FormHelperText error>{errors.No3?.message}</FormHelperText>
        </FormControl>
        <FormControl component="fieldset" margin="normal">
          <FormLabel component="legend">部署名・店舗名</FormLabel>
          <Controller
            name="No4"
            control={control}
            render={({ field }) => (
              <TextField {...field} required={false} fullWidth margin="normal" value={data.No4} inputMode="text" multiline={false} placeholder={"中部支社"} onChange={(event) => {
                setData({ ...data, No4: event.target.value })
                setValue("No4", event.target.value, { shouldValidate: true })
              }
              } />
            )}
          />
          <FormHelperText error>{errors.No4?.message}</FormHelperText>
        </FormControl>
        <FormControl component="fieldset" margin="normal">
          <FormLabel component="legend">役職</FormLabel>
          <Controller
            name="No5"
            control={control}
            render={({ field }) => (
              <Select {...field} onChange={(event) => {
                setData({ ...data, No5: event.target.value as typeof data.No5 })
                setValue("No5", event.target.value as any, { shouldValidate: true })
              }}>
                {
                  optionsNo5.map((option) => {
                    return (
                      <MenuItem value={option} children={option} />
                    )
                  })
                }
              </Select>
            )}
          />
          <FormHelperText error>{errors.No5?.message}</FormHelperText>
        </FormControl>
        <FormControl component="fieldset" margin="normal">
          <FormLabel component="legend">ご利用の家賃債務保証会社・管理会社名</FormLabel>
          <Controller
            name="No6"
            control={control}
            render={({ field }) => (
              <TextField {...field} required={false} fullWidth margin="normal" value={data.No6} inputMode="text" multiline={false} placeholder={"中部電力ミライズコネクト株式会社"} onChange={(event) => {
                setData({ ...data, No6: event.target.value })
                setValue("No6", event.target.value, { shouldValidate: true })
              }
              } />
            )}
          />
          <FormHelperText error>{errors.No6?.message}</FormHelperText>
        </FormControl>
        <FormControl component="fieldset" margin="normal" required>
          <FormLabel component="legend">お名前</FormLabel>
          <Controller
            name="No7"
            control={control}
            render={({ field }) => (
              <TextField {...field} required={true} fullWidth margin="normal" value={data.No7} inputMode="text" multiline={false} placeholder={"中電　太郎"} onChange={(event) => {
                setData({ ...data, No7: event.target.value })
                setValue("No7", event.target.value, { shouldValidate: true })
              }
              } />
            )}
          />
          <FormHelperText error>{errors.No7?.message}</FormHelperText>
        </FormControl>
        <FormControl component="fieldset" margin="normal" required>
          <FormLabel component="legend">フリガナ</FormLabel>
          <Controller
            name="No8"
            control={control}
            render={({ field }) => (
              <TextField {...field} required={true} fullWidth margin="normal" value={data.No8} inputMode="text" multiline={false} placeholder={"チュウデン　タロウ"} onChange={(event) => {
                setData({ ...data, No8: event.target.value })
                setValue("No8", event.target.value, { shouldValidate: true })
              }
              } />
            )}
          />
          <FormHelperText error>{errors.No8?.message}</FormHelperText>
        </FormControl>
        <FormControl component="fieldset" margin="normal" required>
          <FormLabel component="legend">電話番号</FormLabel>
          <Controller
            name="No9"
            control={control}
            render={({ field }) => (
              <TextField {...field} required={true} fullWidth margin="normal" value={data.No9} inputMode="tel" multiline={false} placeholder={"090-1234-5678"} onChange={(event) => {
                setData({ ...data, No9: event.target.value })
                setValue("No9", event.target.value, { shouldValidate: true })
              }
              } />
            )}
          />
          <FormHelperText error>{errors.No9?.message}</FormHelperText>
        </FormControl>
        <FormControl component="fieldset" margin="normal" required>
          <FormLabel component="legend">メールアドレス</FormLabel>
          <Controller
            name="No10"
            control={control}
            render={({ field }) => (
              <TextField {...field} required={true} fullWidth margin="normal" value={data.No10} inputMode="email" multiline={false} placeholder={"chuden.taro@miraiz-connect.co.jp"} onChange={(event) => {
                setData({ ...data, No10: event.target.value })
                setValue("No10", event.target.value, { shouldValidate: true })
              }
              } />
            )}
          />
          <FormHelperText error>{errors.No10?.message}</FormHelperText>
        </FormControl>
        <FormControl component="fieldset" margin="normal" required>
          <FormLabel component="legend">住所</FormLabel>
          <Controller
            name="No11"
            control={control}
            render={({ field }) => (
              <TextField {...field} required={true} fullWidth margin="normal" value={data.No11} inputMode="text" multiline={false} placeholder={"愛知県名古屋市中区栄4-5-3"} onChange={(event) => {
                setData({ ...data, No11: event.target.value })
                setValue("No11", event.target.value, { shouldValidate: true })
              }
              } />
            )}
          />
          <FormHelperText error>{errors.No11?.message}</FormHelperText>
        </FormControl>
        <FormControl component="fieldset" margin="normal" required>
          <FormLabel component="legend">テラシテRを知ったきっかけを教えてください</FormLabel>
          <Controller
            name="No12"
            control={control}
            render={({ field }) => (
              <RadioGroup {...field}>
                {
                  optionsNo12.map((option) => {
                    return (
                      <FormControlLabel value={option} control={<Radio />} label={option} onChange={() => {
                        setData({ ...data, No12: option })
                        setValue("No12", option, { shouldValidate: true })
                      }
                      } />
                    )
                  })
                }
              </RadioGroup>
            )}
          />
          <FormHelperText error>{errors.No12?.message}</FormHelperText>
        </FormControl>
        <FormControl component="fieldset" margin="normal" required>
          <FormLabel component="legend">お問合せ内容</FormLabel>
          <Controller
            name="No13"
            control={control}
            render={({ field }) => (
              <RadioGroup {...field}>
                {
                  optionsNo13.map((option) => {
                    return (
                      <FormControlLabel value={option} control={<Radio />} label={option} onChange={() => {
                        setData({ ...data, No13: option })
                        setValue("No13", option, { shouldValidate: true })
                      }
                      } />
                    )
                  })
                }
              </RadioGroup>
            )}
          />
          <FormHelperText error>{errors.No13?.message}</FormHelperText>
        </FormControl>
        <FormControl component="fieldset" margin="normal">
          <FormLabel component="legend">お問合せ内容詳細</FormLabel>
          <Controller
            name="No14"
            control={control}
            render={({ field }) => (
              <TextField {...field} required={false} fullWidth margin="normal" value={data.No14} inputMode="text" multiline={false} placeholder={"こちらにお問合せ内容の詳細をご記入ください。"} onChange={(event) => {
                setData({ ...data, No14: event.target.value })
                setValue("No14", event.target.value, { shouldValidate: true })
              }
              } />
            )}
          />
          <FormHelperText error>{errors.No14?.message}</FormHelperText>
        </FormControl>
        <FormControl component="fieldset" margin="normal" required>
          <FormLabel component="legend">個人情報保護基本方針について(リンクは<Link href="https://miraiz-connect.co.jp/privacy/policy/" target="_blank">こちら</Link>)</FormLabel>
          <Controller
            name="No15"
            control={control}
            render={({ field }) => (
              <RadioGroup {...field}>
                {
                  optionsNo15.map((option) => {
                    return (
                      <FormControlLabel value={option} control={<Radio />} label={option} onChange={() => {
                        setData({ ...data, No15: option })
                        setValue("No15", option, { shouldValidate: true })
                      }
                      } />
                    )
                  })
                }
              </RadioGroup>
            )}
          />
          <FormHelperText error>{errors.No15?.message}</FormHelperText>
        </FormControl>

      </Box>
    </Box >
  )
}

export default InputForm